import { StorePack } from "../../entity/StorePack";
import { toDate } from "../../utils/GlobalFunctions";
import { StorePackDto } from "../dto/StorePack.Dto";

export const mapStorePackDtoToStorePack = (
  dto: StorePackDto[],
): StorePack[] => {
  return dto.map((pack) => ({
    description: pack.description,
    urlRedirect: pack.urlRedirect,
    id: pack.id,
    updatedAt: toDate(pack.updatedAt),
    createdAt: toDate(pack.createdAt),
    price: pack.price,
    name: pack.name,
    features: pack.features,
  }));
};
